import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import loginHero from '../assets/images/login_hero.png';
import ErrorBoundary from '../components/ErrorBoundary';

const AuthLayout = () => {
  const location = useLocation();
  return (
    <div className="min-h-screen flex" data-testid="auth-layout">
      {/* Left side - Form */}
      <div className="w-full lg:w-2/5 flex items-center justify-center p-6 sm:p-8 bg-white">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="mb-8">
            <h1 className="text-2xl font-semibold tracking-tight text-slate-900" data-testid="auth-logo">
              epicplan
            </h1>
            <p className="text-sm text-slate-500 mt-1">Create Epic Plans</p>
          </div>
          
          {/* Form content */}
          <ErrorBoundary variant="section" name="auth-page" resetKeys={[location.pathname]}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
      
      {/* Right side - Image */}
      <div className="hidden lg:block lg:w-3/5 relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${loginHero})` }}
        >
          {/* Subtle overlay for edge definition */}
          <div className="absolute inset-0 bg-black/5" />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
